import { generateDeck, type GameCard } from '../shared/deck';
import { collectionSymbolCount, DEFAULT_CARD_BACK, type CardCollection } from '../shared/collections';
import { CLASSIC_SYMBOLS } from '../shared/classic-symbols';
import { SYMBOLS } from '../shared/symbols';
import { symbolNamesPtBR } from './locales/common.pt-BR';
import type { Locale } from './i18n';

export interface PackPreview {
  name: string;
  collection: CardCollection | null;
  cards: GameCard[];
  symbols: { id: number; name: string; image: string }[];
}

/** Read-only previews use web artwork directly: opening a pack never installs it. */
export function describePackPreview(pack: CardCollection | 'classic' | null, locale: Locale): PackPreview {
  if (pack === null) return {
    name: 'Náutico / Recife', collection: null, cards: generateDeck(7),
    symbols: SYMBOLS.map(symbol => ({ id: symbol.id, name: locale === 'pt-BR' ? symbolNamesPtBR[symbol.id] : symbol.name,
      image: symbol.assetPath!.replace('/symbols/', '/symbols/web/').replace(/\.png$/, '.webp') })),
  };
  const collection: CardCollection = pack === 'classic' ? {
    id: 'preview_classic', name: locale === 'pt-BR' ? 'Clássico' : 'Classique', order: 7,
    // These URLs stay inside this preview; portable collection validation is not involved.
    symbols: CLASSIC_SYMBOLS.map(symbol => ({ id: symbol.id, name: locale === 'pt-BR' ? symbol.pt : symbol.name, image: symbol.thumbnail })),
    back: { ...DEFAULT_CARD_BACK }, createdAt: 0, updatedAt: 0,
  } : pack;
  return {
    name: collection.name, collection,
    cards: collection.symbols.length === collectionSymbolCount(collection.order) ? generateDeck(collection.order) : [],
    symbols: collection.symbols.map(({ id, name, image }) => ({ id, name, image })),
  };
}
